<div class="d-flex justify-content-between automation-{{plan.planCode}}">
  <div class="d-flex flex-column w-75">
    <div class="gb-body1 mb-3">
      <div class="heavy gb-body1" [ngClass]="{'mb-3': plan.planDatesText}">
        <span *ngIf="isVehicleOverviewPage" class="automation-plan-name automation-{{plan.planCode}}">{{plan.planId}}</span>
        <!-- <a  *ngIf="!isVehicleOverviewPage" id="modalLink{{plan.planCode}}" class="automation-plan-name automation-{{plan.planCode}}"
          (click)="openPlanInfoModal()" href="#">{{plan.planId}}</a> -->
      </div>
      <div class="gb-body1" *ngIf="plan.planDatesText">
        <p class="plan-date-text">{{plan.planDatesText}}</p>
      </div>
    </div>
  </div>
  <div class="gb-body1 heavy recurring-plan-price" *ngIf="userRole === 'OWNER' && plan.price">
    {{plan.price | currency}}
  </div>
</div>
<!--get this from the new assets API-->
<div class="status-bar mb-4" *ngIf="plan && plan.dataRemaining">
  <div class="status-cit2">
    <div class="status-bar-cit2 autmoation-data-remaining-bar" role="progressbar" [ngStyle]="{'width': plan.dataPercentRemaining + '%'}" aria-valuenow="25" aria-valuemin="0"
        aria-valuemax="100"></div>
  </div>
  <div class="gb-body2 automation-data-remaining-copy">{{plan.dataRemaining}}</div>
</div>
